import { Rocket } from "lucide-react";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { etLocalToIso, isoToEtLocal, tomorrowLaunchLocal, formatEt } from "@/lib/eastern";

export const LaunchGateSettings = ({ settings, set }) => {
  const enabled = !!settings.launch_gate_enabled;
  const live = settings.launch_at && new Date(settings.launch_at) <= new Date();
  return (
    <div className="space-y-4" data-testid="launch-gate-settings">
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="eyebrow mb-1 flex items-center gap-1.5"><Rocket size={12} /> Launch gate</p>
          <p className="text-xs text-slate-500">While on, visitors see a "Launching soon" countdown instead of the site until the go-live time, then it unlocks itself. Team members who are signed in still see the full site. The survey, admin and publish pages stay reachable.</p>
        </div>
        <Switch checked={enabled} onCheckedChange={(v) => set("launch_gate_enabled", v)} data-testid="launch-gate-toggle" />
      </div>
      {enabled && (
        <div className="rounded-2xl border border-white/10 bg-white/5 p-4 space-y-3">
          <Label>Go-live time <span className="text-slate-500">(Eastern Time — New York)</span></Label>
          <div className="flex flex-wrap gap-2">
            <input type="datetime-local" value={isoToEtLocal(settings.launch_at)} onChange={(e) => set("launch_at", etLocalToIso(e.target.value))} className="h-10 rounded-md bg-white/5 border border-white/10 px-3 text-sm" data-testid="launch-at-input" />
            <button type="button" onClick={() => set("launch_at", etLocalToIso(tomorrowLaunchLocal()))} className="h-10 rounded-full border border-white/15 px-4 text-xs font-bold hover:bg-white/10" data-testid="launch-at-tomorrow-button">Tomorrow 12:01 AM ET</button>
          </div>
          <p className="text-xs text-slate-400" data-testid="launch-at-summary">
            {!settings.launch_at && "No time set — the gate stays up until you pick one or switch it off."}
            {settings.launch_at && (live ? "That time has passed — the site is live." : <>Site unlocks {formatEt(settings.launch_at)}.</>)}
          </p>
        </div>
      )}
    </div>
  );
};
